import NetworkProvider from './NetworkProvider.container'

export default NetworkProvider
